import { buildTourApiUrl } from "api/configuration";
import { http } from "api/http";

export const getOperatorAndCarrierIds = (
  tourIds: string[]
): Promise<string[]> => {
  const url = buildTourApiUrl(
    `/deliverytours/getOperatorAndCarrierIds`
  );
  return http.post(url, JSON.stringify(tourIds));
};
